import classNames from "classnames";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import Content from "./content";
import classes from "./expandable-container.module.scss";
import Header from "./header";

function ExpandableContainer({
  header,
  isEnabled,
  isOpen: initialOpen,
  direction: initialDirection,
  animationDuration,
  animationDelay,
  children,
  onToggle,
  className,
  style,
}) {
  const [isOpen, setOpen] = useState(initialOpen);
  const [direction, setDirection] = useState(initialDirection);

  useEffect(() => {
    setDirection(initialDirection);
  }, [initialDirection]);

  useEffect(() => {
    setOpen(initialOpen);
  }, [initialOpen]);

  const handleClick = () => {
    if (!isEnabled) {
      return;
    }

    if (onToggle) {
      onToggle(!isOpen);
    } else {
      setOpen(!isOpen);
    }
  };

  return (
    <div
      className={classNames(classes.container, classes[direction], className)}
      style={style}
    >
      {header && (
        <Header onClick={handleClick}>
          <header.type
            {...header.props}
            isEnabled={isEnabled}
            isOpen={isOpen}
          />
        </Header>
      )}

      <Content
        animationDuration={animationDuration}
        animationDelay={animationDelay}
        direction={direction}
        isOpen={isOpen}
      >
        {children}
      </Content>
    </div>
  );
}

ExpandableContainer.propTypes = {
  ...Content.propTypes,
  isEnabled: PropTypes.bool.isRequired,
  header: PropTypes.node,
  children: PropTypes.node,
};

ExpandableContainer.defaultProps = {
  ...Content.defaultProps,
  isEnabled: true,
};

export default ExpandableContainer;
